import { Injectable } from '@angular/core';

// declare let paymentV2AB;
declare let story_one_tap_AB;
declare let slab_AB;
declare let repeatorder_ministoryAB;
declare let thankyou_standard_AB;
declare let payu_AB;
declare let dm_AB;
declare let quickDonate_fallback_p1_AB;
declare let quickDonate_fr_AB;
declare let kcart_fr_urgent_tag_AB;
declare let story_variation_5;
declare let tip_desktop_story_AB;
declare let kcart_tip_story_AB; // (vwo.kcart_tip_story_AB() && vars.showKCart) remove in tip comp after result
declare let kcart_slab_AB;
declare let kcart_stories_ctachange_AB;
declare let kcart_not_preselected_AB;
declare let csat_typ_AB;
declare let phonepe_qr_AB;
declare let fundraiser_on_story_AB;
declare let otd_sip_AB;
declare let revamp_homepage_nonloggedin_AB;
declare let fundraiser_tip_badge_AB;
declare let slab_changes_tip_AB;
declare let story_blur_image_ABC;
declare let supporter_kart_details_AB;
declare let zero_tip_AB;
declare let support_fee_AB;
declare let browse_fundraiser_random_campaign_AB;
declare let insurance_optin_amount_AB;
declare let blur_image_AB;
declare let saf_AB;
declare let kcart_default_unit_AB;
declare let medical_landing_AB;

declare let kettokart_utm_pricechange_AB;
declare let multi_patient_note_AB;
declare let exit_intent_AB;
declare let new_upi_AB;
declare let fundraiser_tip_typ_AB;
declare let fundraiser_invite_banner_AB;
declare let payment_otd_AB;

@Injectable({
  providedIn: 'root'
})
export class VwoService {


  // paymentV2AB() {
  //   if (typeof paymentV2AB !== 'undefined') {
  //     return paymentV2AB;
  //   }
  // }

  getFromSession(key: string) {
    if (typeof window === 'undefined' || typeof sessionStorage === 'undefined') return false;
    return sessionStorage.getItem(key) || false;
  }

  setInSession(key: string, value: any) {
    if (typeof window === 'undefined' || typeof sessionStorage === 'undefined') return false;
    sessionStorage.setItem(key, value);
    return true;
  }

  fundraiser_invite_banner_AB() {
    if (typeof fundraiser_invite_banner_AB !== 'undefined') {
      return fundraiser_invite_banner_AB;
    }
  }

  exit_intent_AB() {
    if (typeof exit_intent_AB !== 'undefined') {
      return exit_intent_AB;
    }
  }

  story_one_tap_AB() {
    if (typeof story_one_tap_AB !== 'undefined') {
      return story_one_tap_AB;
    }
  }

  slab_AB() {
    if (typeof slab_AB !== 'undefined') {
      return slab_AB;
    }
    // return 'non_inr_ab'
  }

  repeatorder_ministoryAB() {
    if (typeof repeatorder_ministoryAB !== 'undefined') {
      return repeatorder_ministoryAB;
    }
  }

  thankyou_standard_AB() {
    if (typeof thankyou_standard_AB !== 'undefined') {
      return thankyou_standard_AB;
    }
  }

  payu_AB() {
    if (typeof payu_AB !== 'undefined') {
      return payu_AB;
    }
  }

  dm_AB() {
    if (typeof dm_AB !== 'undefined') {
      return dm_AB;
    }
  }

  quickDonate_fallback_p1_AB() {
    if (typeof quickDonate_fallback_p1_AB !== 'undefined') {
      return quickDonate_fallback_p1_AB;
    }
  }

  quickDonate_fr_AB() {
    if (typeof quickDonate_fr_AB !== 'undefined') {
      return quickDonate_fr_AB;
    }
  }

  kcart_fr_urgent_tag_AB() {
    if (typeof kcart_fr_urgent_tag_AB !== 'undefined') {
      return kcart_fr_urgent_tag_AB;
    }
  }

  story_variation_5() {
    if (typeof story_variation_5 !== 'undefined') {
      return story_variation_5;
    }
  }

  tip_desktop_story_AB() {
    if (typeof tip_desktop_story_AB !== 'undefined') {
      return tip_desktop_story_AB;
    }
  }

  kcart_tip_story_AB() {
    if (typeof kcart_tip_story_AB !== 'undefined') {
      return kcart_tip_story_AB;
    }
  }

  kcart_slab_AB() {
    if (typeof kcart_slab_AB !== 'undefined') {
      return kcart_slab_AB;
    }
  }

  kcart_stories_ctachange_AB() {
    if (typeof kcart_stories_ctachange_AB !== 'undefined') {
      return kcart_stories_ctachange_AB;
    }
  }

  kcart_not_preselected_AB() {
    if (typeof kcart_not_preselected_AB !== 'undefined') {
      return kcart_not_preselected_AB;
    }
  }

  csat_typ_AB() {
    if (typeof csat_typ_AB !== 'undefined') {
      return csat_typ_AB;
    }
  }

  phonepe_qr_AB() {
    if (typeof phonepe_qr_AB !== 'undefined') {
      return phonepe_qr_AB;
    }
  }

  fundraiser_on_story_AB() {
    if (typeof fundraiser_on_story_AB !== 'undefined') {
      return fundraiser_on_story_AB;
    }
  }

  otd_sip_AB() {
    const sessionData = this.getFromSession('otd_sip_AB');
    if (sessionData) {
      return sessionData;
    }
    if (typeof otd_sip_AB !== 'undefined') {
      this.setInSession('otd_sip_AB', otd_sip_AB);
      return otd_sip_AB;
    }
  }

  revamp_homepage_nonloggedin_AB() {
    if (typeof revamp_homepage_nonloggedin_AB !== 'undefined') {
      return revamp_homepage_nonloggedin_AB;
    }
  }

  fundraiser_tip_badge_AB() {
    if (typeof fundraiser_tip_badge_AB !== 'undefined') {
      return fundraiser_tip_badge_AB;
    }
  }

  slab_changes_tip_AB() {
    if (typeof slab_changes_tip_AB !== 'undefined') {
      return slab_changes_tip_AB;
    }
  }

  story_blur_image_ABC() {
    if (typeof story_blur_image_ABC !== 'undefined') {
      return story_blur_image_ABC;
    }
  }

  supporter_kart_details_AB() {
    if (typeof supporter_kart_details_AB !== 'undefined') {
      return supporter_kart_details_AB;
    }
  }

  zero_tip_AB() {
    if (typeof zero_tip_AB !== 'undefined') {
      return zero_tip_AB;
    }
  }

  support_fee_AB() {
    if (typeof support_fee_AB !== 'undefined') {
      return support_fee_AB;
    }
  }

  saf_AB() {
    if (typeof saf_AB !== 'undefined') {
      return saf_AB;
    }
  }

  browse_fundraiser_random_campaign_AB() {
    if (typeof browse_fundraiser_random_campaign_AB !== 'undefined') {
      return browse_fundraiser_random_campaign_AB;
    }
  }


  blur_image_AB() {
    const sessionData = this.getFromSession('blur_image_AB');
    if (sessionData) {
      return sessionData;
    }
    if (typeof blur_image_AB !== 'undefined') {
      this.setInSession('blur_image_AB', blur_image_AB);
      return blur_image_AB;
    }
  }

  insurance_optin_amount_AB() {
    if (typeof insurance_optin_amount_AB !== 'undefined') {
      return insurance_optin_amount_AB;
    }
  }

  kcart_default_unit_AB() {
    if (typeof kcart_default_unit_AB !== 'undefined') {
      return kcart_default_unit_AB;
    }
  }

  medical_landing_AB() {
    if (typeof medical_landing_AB !== 'undefined') {
      return medical_landing_AB;
    }
  }

  kettokart_utm_pricechange_AB() {
    if (typeof kettokart_utm_pricechange_AB !== 'undefined') {
      return kettokart_utm_pricechange_AB;
    }
  }

  multi_patient_note_AB() {
    const sessionData = this.getFromSession('multi_patient_note_AB');
    if (sessionData) {
      return sessionData;
    }
    if (typeof multi_patient_note_AB !== 'undefined') {
      this.setInSession('multi_patient_note_AB', multi_patient_note_AB);
      return multi_patient_note_AB;
    }
  }

  new_upi_AB() {
    const sessionData = this.getFromSession('new_upi_AB');
    if (sessionData) {
      return sessionData;
    }
    if (typeof new_upi_AB !== 'undefined') {
      this.setInSession('new_upi_AB', new_upi_AB);
      return new_upi_AB;
    }
  }

  fundraiser_tip_typ_AB() {
    if (typeof fundraiser_tip_typ_AB !== 'undefined') {
      return fundraiser_tip_typ_AB;
    }
  }

  payment_otd_AB() {
    const sessionData = this.getFromSession('payment_otd_AB');
    if (sessionData) {
      return sessionData;
    }
    if (typeof payment_otd_AB !== 'undefined') {
      this.setInSession('payment_otd_AB', payment_otd_AB);
      return payment_otd_AB;
    }
  }
}
